module.exports = __webpack_public_path__ + "static/img/newanli-24.f7aee203.jpg";